import { graphql } from "@/types/gql";

export const QUERY_WORK_AREAS = graphql(`
  query findWorkAreas($cityId: String!) {
    workAreas(cityId: $cityId) {
      id
      name
      done
      geometry
      cityId
    }
  }
`);

export const QUERY_ADD_WORK_AREA = graphql(`
  mutation createWorkArea($workAreaInput: CreateWorkAreaInput!) {
    createWorkArea(workAreaInput: $workAreaInput) {
      id
      name
      done
      geometry
      cityId
    }
  }
`);

export const QUERY_UPDATE_WORK_AREA = graphql(`
  mutation updateWorkArea($workAreaInput: UpdateWorkAreaInput!) {
    updateWorkArea(workAreaInput: $workAreaInput) {
      id
      name
      done
      geometry
      cityId
    }
  }
`);

export const QUERY_REMOVE_WORK_AREA = graphql(`
  mutation deleteWorkArea($id: String!) {
    deleteWorkArea(id: $id) {
      id
    }
  }
`);
